import { render, staticRenderFns } from "./ReferenceCell.vue?vue&type=template&id=630b0a7d&"
import script from "./ReferenceCell.vue?vue&type=script&lang=js&"
export * from "./ReferenceCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReferenceCell.vue"
export default component.exports